// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.main-content {
  padding: 34px;
}
.main-content.enter-tracking-number {
  display: flex;
  justify-content: center;
}
.main-content.enter-tracking-number .tracking-number-form {
  max-width: 774px;
  width: 100%;
  padding: 40px 56px 50px;
}
.main-content.enter-tracking-number .tracking-number-form .form-title {
  width: 100%;
  margin-top: 0;
  margin-bottom: 33px;
}
.main-content.enter-tracking-number .tracking-number-form .inputField {
  margin-bottom: 22px !important;
}
.main-content.enter-tracking-number .tracking-number-form .inputField:first-child {
  margin-bottom: 25px !important;
}

#header-div {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 75px;
  flex-shrink: 0;
  background: #0740a3;
}

#header-div-logo {
  padding-bottom: 15px;
}

#footer-div {
  background-color: white;
  padding: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

#parcel-tracking {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 97px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(137, 137, 137, 0.25);
}

#parcel-tracking-left {
  display: flex;
  flex-direction: column;
  padding-left: 125px;
  text-align: left;
}

#tracking-btn {
  display: flex;
  width: 183px;
  height: 40px;
  padding: 8px 12px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--BTBlue-Primary, #008ff6);
}

#tracking-text {
  color: #4e4e4e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

#tracking-number {
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
}

#parcel-tracking-right {
  padding-right: 125px;
}

#address-error {
  color: #000;
  font-family: Roboto;
  line-height: normal;
  height: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #c9171f;
  background: rgba(201, 23, 31, 0.1);
  margin: 34px 34px 0 34px;
  padding: 10px;
}

#address-warning {
  color: #000;
  font-family: Roboto;
  line-height: normal;
  height: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ed6c02;
  padding: 10px;
}

#address-error-icon {
  margin-right: 10px;
  padding: 0 15px;
}

#address-error-text {
  display: flex;
  flex-direction: column;
}

.form-title {
  width: 366px;
  height: 20px;
  flex-shrink: 0;
  text-align: left;
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.address-section,
.tracking-number-form {
  flex-shrink: 0;
  border-radius: 4px 0px 0px 4px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(137, 137, 137, 0.25);
}

#splitter {
  width: 100%;
  height: 1px;
  background: #e1e1e1;
}

#recepient-placeholder {
  text-align: left;
  margin-top: 24px;
}

#recepient-text {
  color: #4e4e4e;
  font-family: "Roboto Mono";
  font-size: 14px;
}

#recepient-name {
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}

.input-wrapper {
  flex: 1 1;
  gap: 8px;
}

#update-address-btn {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--BTBlue-Primary, #008ff6);
}

.city-field-div {
  padding-right: 4px;
}

.zip-field-div {
  padding-left: 4px;
}

#spinner-div {
  padding: 50px 0px;
}

.inputField,
.input-group {
  margin-bottom: 15px !important;
}

.notes-field {
  margin-top: 15px !important;
}

.inputButton {
  margin: 15px 0 !important;
}

.roboto-capital {
  font-family: Roboto;
  text-transform: uppercase;
}

.col-address {
  width: 50%;
}

@media (max-width: 768px) {
  .col-address {
    width: 100%;
  }
  .inputButton {
    margin-top: 10px;
  }
  #parcel-tracking {
    text-align: center;
  }
  #parcel-tracking-left {
    display: flex;
    flex-direction: column;
    padding-left: 125px;
    text-align: center;
  }
  #address-error,
  #address-warning {
    align-items: flex-start;
    margin: 20px 20px 0 20px;
    text-align: left;
  }
  #address-error-icon {
    padding: 0;
  }
  #parcel-tracking-right {
    display: none;
  }
  .main-content.enter-tracking-number {
    padding-left: 8px;
    padding-right: 8px;
  }
  .main-content.enter-tracking-number .tracking-number-form {
    padding: 24px 16px 32px;
  }
  .main-content.enter-tracking-number .tracking-number-form .form-title {
    font-size: 16px;
    margin-bottom: 24px;
  }
  .main-content.enter-tracking-number .tracking-number-form .inputField {
    margin-bottom: 24px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,kJAAA;EAEA,mCAAA;EACA,kCAAA;AAAF;;AAGA;EACE,+EAAA;AAAF;;AAIA;EACE,aAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;AADJ;AAGI;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;AADN;AAGM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AADR;AAIM;EACE,8BAAA;AAFR;AAIQ;EACE,8BAAA;AAFV;;AASA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AANF;;AASA;EACE,oBAAA;AANF;;AASA;EACE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qDAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;AANF;;AASA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANF;;AASA;EACE,WAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AANF;;AASA;EACE,oBAAA;AANF;;AASA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kCAAA;EACA,wBAAA;EACA,aAAA;AANF;;AASA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AANF;;AASA;EACE,kBAAA;EACA,eAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AANF;;AASA;;EAEE,cAAA;EACA,8BAAA;EACA,gBAAA;EACA,qDAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANF;;AASA;EACE,SAAA;EACA,QAAA;AANF;;AASA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;;EAEE,8BAAA;AANF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,yBAAA;AANF;;AASA;EACE,mBAAA;EACA,yBAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE;IACE,WAAA;EANF;EAQA;IACE,gBAAA;EANF;EAQA;IACE,kBAAA;EANF;EAQA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;EANF;EAQA;;IAEE,uBAAA;IACA,wBAAA;IACA,gBAAA;EANF;EAQA;IACE,UAAA;EANF;EAQA;IACE,aAAA;EANF;EASA;IACE,iBAAA;IACA,kBAAA;EAPF;EASE;IACE,uBAAA;EAPJ;EASI;IACE,eAAA;IACA,mBAAA;EAPN;EAUI;IACE,8BAAA;EARN;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.main-content {\n  padding: 34px;\n\n  &.enter-tracking-number {\n    display: flex;\n    justify-content: center;\n\n    .tracking-number-form {\n      max-width: 774px;\n      width: 100%;\n      padding: 40px 56px 50px;\n\n      .form-title {\n        width: 100%;\n        margin-top: 0;\n        margin-bottom: 33px;\n      }\n\n      .inputField {\n        margin-bottom: 22px !important;\n\n        &:first-child {\n          margin-bottom: 25px !important;\n        }\n      }\n    }\n  }\n}\n\n#header-div {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  height: 75px;\n  flex-shrink: 0;\n  background: #0740a3;\n}\n\n#header-div-logo {\n  padding-bottom: 15px;\n}\n\n#footer-div {\n  background-color: white;\n  padding: 20px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n#parcel-tracking {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 97px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0px 4px 4px 0px rgba(137, 137, 137, 0.25);\n}\n\n#parcel-tracking-left {\n  display: flex;\n  flex-direction: column;\n  padding-left: 125px;\n  text-align: left;\n}\n\n#tracking-btn {\n  display: flex;\n  width: 183px;\n  height: 40px;\n  padding: 8px 12px;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background: var(--BTBlue-Primary, #008ff6);\n}\n\n#tracking-text {\n  color: #4e4e4e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n#tracking-number {\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  text-align: left;\n}\n\n#parcel-tracking-right {\n  padding-right: 125px;\n}\n\n#address-error {\n  color: #000;\n  font-family: Roboto;\n  line-height: normal;\n  height: auto;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #c9171f;\n  background: rgba(201, 23, 31, 0.1);\n  margin: 34px 34px 0 34px;\n  padding: 10px;\n}\n\n#address-warning {\n  color: #000;\n  font-family: Roboto;\n  line-height: normal;\n  height: auto;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #ed6c02;\n  padding: 10px;\n}\n\n#address-error-icon {\n  margin-right: 10px;\n  padding: 0 15px;\n}\n\n#address-error-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-title {\n  width: 366px;\n  height: 20px;\n  flex-shrink: 0;\n  text-align: left;\n  color: #000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.address-section,\n.tracking-number-form {\n  flex-shrink: 0;\n  border-radius: 4px 0px 0px 4px;\n  background: #fff;\n  box-shadow: 0px 4px 4px 0px rgba(137, 137, 137, 0.25);\n}\n\n#splitter {\n  width: 100%;\n  height: 1px;\n  background: #e1e1e1;\n}\n\n#recepient-placeholder {\n  text-align: left;\n  margin-top: 24px;\n}\n\n#recepient-text {\n  color: #4e4e4e;\n  font-family: \"Roboto Mono\";\n  font-size: 14px;\n}\n\n#recepient-name {\n  color: #000;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}\n\n.input-wrapper {\n  flex: 1;\n  gap: 8px;\n}\n\n#update-address-btn {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 8px 12px;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background: var(--BTBlue-Primary, #008ff6);\n}\n\n.city-field-div {\n  padding-right: 4px;\n}\n\n.zip-field-div {\n  padding-left: 4px;\n}\n\n#spinner-div {\n  padding: 50px 0px;\n}\n\n.inputField,\n.input-group {\n  margin-bottom: 15px !important;\n}\n\n.notes-field {\n  margin-top: 15px !important;\n}\n\n.inputButton {\n  margin: 15px 0 !important;\n}\n\n.roboto-capital {\n  font-family: Roboto;\n  text-transform: uppercase;\n}\n\n.col-address {\n  width: 50%;\n}\n\n@media (max-width: 768px) {\n  .col-address {\n    width: 100%;\n  }\n  .inputButton {\n    margin-top: 10px;\n  }\n  #parcel-tracking {\n    text-align: center;\n  }\n  #parcel-tracking-left {\n    display: flex;\n    flex-direction: column;\n    padding-left: 125px;\n    text-align: center;\n  }\n  #address-error,\n  #address-warning {\n    align-items: flex-start;\n    margin: 20px 20px 0 20px;\n    text-align: left;\n  }\n  #address-error-icon {\n    padding: 0;\n  }\n  #parcel-tracking-right {\n    display: none;\n  }\n\n  .main-content.enter-tracking-number {\n    padding-left: 8px;\n    padding-right: 8px;\n\n    .tracking-number-form {\n      padding: 24px 16px 32px;\n\n      .form-title {\n        font-size: 16px;\n        margin-bottom: 24px;\n      }\n\n      .inputField {\n        margin-bottom: 24px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
